import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './common/main/main.component';
import { MasterRoutes } from './core/constants/route.constant';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: MasterRoutes.Home,
        loadChildren: () =>
          import('./modules/home/home.module').then(
            (m) => m.HomeModule
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/home/home.module').then(
            (m) => m.HomeModule
          ),
      },
      {
        path: MasterRoutes.Configure,
        loadChildren: () =>
          import('./modules/configure/configure.module').then(
            (m) => m.ConfigureModule
          ),
      },
      {
        path: MasterRoutes.PatientEnrollment,
        loadChildren: () =>
          import('./modules/patient-enrollment/patient-enrollment.module').then(
            (m) => m.PatientEnrollmentModule
          ),
      },
      {
        path: MasterRoutes.Reports,
        loadChildren: () =>
          import('./modules/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
      },
      {
        path: MasterRoutes.MyAccount,
        loadChildren: () =>
          import('./modules/account/account.module').then(
            (m) => m.AccountModule
          ),
      },
      {
        path: MasterRoutes.Alerts,
        loadChildren: () =>
          import('./modules/alerts/alerts.module').then(
            (m) => m.AlertsModule
          ),
      }
    ],
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }


